export enum SitePointerShape {
  Circle = 'circle',
  Pentagon = 'pentagon',
  Square = 'square',
  Star = 'star',
}

export enum MapSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Full = 'full',
}
